"use client";

import { DismissableLayer } from "@radix-ui/react-dismissable-layer";
import type { ReactNode } from "react";

export function DialogDismissalLayer({ open, onOpenChange, children }: { open: boolean; onOpenChange: (open: boolean) => void; children?: ReactNode }) {
  if (!open) return null;
  return (
    <DismissableLayer
      className="contents"
      onDismiss={() => onOpenChange(false)}
      onInteractOutside={(event) => event.preventDefault()}
    >
      {children}
    </DismissableLayer>
  );
}
